import * as React from "react";
const SvgCode20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 16,
        fill: "black",
        viewBox: "0 0 20 16"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m8.632 15.265 4.633-13.897-1.898-.633-4.632 13.898 1.897.632ZM7.414 3.5 2.914 8l3.5 3.5L5 12.914.086 8 6 2.086 7.414 3.5Zm6.172 1 3.5 3.5-4.5 4.5L14 13.914 19.914 8 15 3.086 13.586 4.5Z",
      clipRule: "evenodd"
    })
  );
export default SvgCode20Px;
